import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormDomainScriptGuidePageFixService } from './service/page-fix.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'form-domain-script-guide-features-page-fix',
    standalone: false,
    templateUrl: './page-fix.component.html',
})
export class FormDomainScriptGuideFeaturesPageFixComponent implements OnInit, OnDestroy {
    @Input() prefixName?: string;

    show: boolean = false;
    canUse: boolean = false;
    private subscription?: Subscription;

    constructor (
        private formDomainScriptGuidePageFixService: FormDomainScriptGuidePageFixService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    ngOnDestroy () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    activate () {
        this.prefixName = this.prefixName || '';
        this.show = this.formDomainScriptGuidePageFixService.hasAccessToFeature();
        this.canUse = this.formDomainScriptGuidePageFixService.getValue();
        this.setupWatcher();
    }

    onChangeValue () {
        setTimeout(() => {
            this.setValue(this.canUse);
        });
    }

    // PROTECTED
    private setupWatcher () {
        this.subscription = this.formDomainScriptGuidePageFixService.settingChangeObs.subscribe(() => {
            this.canUse = this.formDomainScriptGuidePageFixService.getValue();
        });
    }

    private setValue (value: boolean) {
        this.formDomainScriptGuidePageFixService.setValue(value, true);
    }
}
